/**
 * @file: annotationTagOptionStyle.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import {
  getDefectiveLevel,
  getDefectiveLevelColor,
} from '@euler/functions/getDefectiveLevel';
import { DefaultTheme } from 'styled-components';
import { AnnotationTagOption } from './AnnotationTagOption';
import { AnnotationTagStyle } from './TagInfo';

/**
 * The tag style of an option: painted with the color of the defective level
 * the option resolves to.
 */
export const annotationTagOptionStyle = (
  theme: DefaultTheme,
  option: AnnotationTagOption,
): AnnotationTagStyle => {
  const color = getDefectiveLevelColor(
    theme,
    getDefectiveLevel(option.abnormalLevel, option.severityLevel),
  );
  return { stroke: color, fill: color, textFill: '#FFFFFF' };
};
